/**
 * Scroll-to functionality for hash links on the document
 *
 * @package Embark
 * @since   1.0.0
 */

import $ from 'jquery';
import * as helpers from '../global/helpers';
import { els } from './variables';

/**
 * Scroll to hash on load.
 *
 * @since  1.0.0
 */
function scrollToHashOnLoad() {
	if (window.location.hash) {
		// To top right away.
		window.scroll(0, 0);
		// Void some browsers issue.
		setTimeout(
			() => {
				window.scroll(0, 0);
			}, 1,
		);

		helpers.scrollToEl($(window.location.hash), els.header.offsetHeight);
	}
}

/**
 * Scroll to hash on click, and update URL.
 *
 * @since  1.0.0
 */
function scrollToHashOnClick() {
	if (window.location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && window.location.hostname === this.hostname) {
		const { hash } = this;
		let target = $(hash);
		target = target.length ? target : $(`[name=${hash.slice(1)}]`);
		if (target.length) {
			helpers.scrollToEl(target, els.header.offsetHeight);
			helpers.addHashToURL(hash);
			return false;
		}
	}
	return true;
}

window.addEventListener('load', scrollToHashOnLoad);
$(document).on('click', 'a[href*="#"]:not([href="#"])', scrollToHashOnClick);
